export default __webpack_public_path__ + "static/media/dj.4c3e9b14.png";